.card {
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin: 0 var(--gutter) 16px;
  padding: 18px;
  border: 1px solid var(--border);
  border-radius: var(--r-lg);
  background: var(--surface-1);
}

.proCard {
  border-color: rgb(var(--accent-rgb) / 0.35);
  background: linear-gradient(160deg, var(--accent-soft), var(--surface-1) 60%);
}

.cardTitle {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: var(--fs-lg);
  font-weight: 800;
}

.muted {
  color: var(--text-2);
  font-size: var(--fs-sm);
  line-height: 1.5;
}

.perks {
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin: 0;
  padding: 0;
  list-style: none;
  font-size: var(--fs-sm);
}

.perks li {
  display: flex;
  align-items: center;
  gap: 8px;
}

.perks svg {
  color: var(--accent);
  flex-shrink: 0;
}

.price {
  font-size: var(--fs-xl);
  font-weight: 800;
}

.price small {
  font-size: var(--fs-sm);
  font-weight: 600;
  color: var(--text-3);
}

.row {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-end;
  gap: 8px;
}

.row > label {
  flex: 1;
  min-width: 140px;
}

.stat {
  display: flex;
  justify-content: space-between;
  font-size: var(--fs-sm);
  color: var(--text-2);
}

.stat strong {
  color: var(--text);
}

.people {
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin: 0;
  padding: 0;
  list-style: none;
}

.people li {
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: var(--fs-sm);
}

.people li span {
  flex: 1;
  font-weight: 700;
}

.people li small {
  color: var(--text-3);
}

.badge {
  display: inline-flex;
  align-items: center;
  padding: 2px 8px;
  border-radius: var(--r-full);
  background: var(--accent);
  color: var(--accent-ink);
  font-size: var(--fs-xs);
  font-weight: 800;
  letter-spacing: 0.04em;
}

.pending {
  color: var(--warning);
}
